import React, {Component} from 'react'
import utility from '../utility';
import ReactTooltip from "react-tooltip";
import Select from 'react-select'
import chroma from 'chroma-js';

class Profiles extends Component {

    constructor(props) {
        super(props);
        this.standardForm = React.createRef();
    }

    keypress(e) {
        if (!utility.isNumberKey(e)) {
            e.preventDefault();
        }
    }

    renderProducts() {
        return this.props.products.map((ele, i) => {
            let cls = "product-profile";
            if (i === this.props.active) {
                cls += " active";
            }

            return (
                <div className={cls} key={"pro_" + i} data-name={ele.name}
                     onClick={e => this.props.select(e, "product")} data-key={i}>
                    <img src={ele.url} alt={ele.name}/>
                </div>
            )
        });
    }

    getColor() {
        return Object.keys(this.props.colors).map(k => {
            let color = this.props.colors[k];
            return {value: color.code, label: `RAL ${color.code} ${color.name}`, color: color.hex}
        })
    }

    render() {
        let colors = [{value: "Blank Aluminium", label: `Blank Aluminium`, color: "#848789"}],
            showEdit = this.props.edit !== false, // we added two values just reduced code length
            editValue = this.props.edit,
            c = this.getColor();
        colors = [...colors, ...c];
        const colourStyles = {
            control: styles => ({...styles, backgroundColor: 'white'}),
            option: (styles, {data, isDisabled, isFocused, isSelected}) => {
                const color = chroma(data.color);
                return {
                    ...styles,
                    backgroundColor: isDisabled
                        ? null
                        : isSelected
                            ? data.color
                            : isFocused
                                ? color.alpha(0.1).css()
                                : null,
                    color: isDisabled
                        ? '#ccc'
                        : isSelected
                            ? chroma.contrast(color, 'white') > 2
                                ? 'white'
                                : 'black'
                            : data.color,
                    cursor: isDisabled ? 'not-allowed' : 'default',

                    ':active': {
                        ...styles[':active'],
                        backgroundColor: !isDisabled && (isSelected ? data.color : color.alpha(0.3).css()),
                    },
                };
            }
        };

        return (
            <div className="card product-card border-0 mb-4" data-id={this.props.id}>
                <form onSubmit={e => this.props.save(e)} ref={this.standardForm}>
                    <h5 className="card-header border-0" data-target={"#p-" + this.props.id}
                        onClick={e => this.props.showCard(e)}>Standard Nr.{this.props.id} <span
                        className="float-right icon icon-arrow-up mt-1 arw"></span></h5>
                    <div className="card-body collapse show" id={"p-" + this.props.id}>
                        <div className="col-12 mb-4">
                            <h5 className="card-title">Profile </h5>
                            {this.renderProducts()}
                        </div>

                        <div className="col-12 mb-4">
                            <div className="row">
                                <div className="col-4">
                                    <div className="form-group">
                                        <label htmlFor="d-a">A-Maß</label>
                                        <input required className="form-control d-a"
                                               defaultValue={showEdit && editValue.da && parseInt(editValue.da)}
                                               onChange={e => this.props.change(e)} data-type="da" data-field="d-a"
                                               type="number" spellCheck="false"/>
                                    </div>
                                </div>
                                <div className="col-4">
                                    <div className="form-group">
                                        <label htmlFor="d-b">B-Maß <i data-tip={true} className="icon icon-info"
                                                                      data-for='b-mass'></i></label>
                                        <ReactTooltip type="dark" id='b-mass'>
                                            <span>Bitte berücksichtigen sie einen ausreichenden Überstand Außenseite und Innenmaß (Wir empfehlen mindestens 35mm links von der Mauer und rechts von der Mauer)</span>
                                        </ReactTooltip>
                                        <input required className="form-control d-b"
                                               defaultValue={showEdit && editValue.db && parseInt(editValue.db)}
                                               onChange={e => {
                                                   this.setState({bmass: e.target.value});
                                                   this.props.change(e)
                                               }} data-type="db" data-field="d-b" type="number" spellCheck="false"/>
                                    </div>
                                </div>
                                <div className="col-4">
                                    <div className="form-group">
                                        <label htmlFor="d-c">C-Maß</label>
                                        <input required className="form-control d-c"
                                               defaultValue={showEdit && editValue.dc && parseInt(editValue.dc)}
                                               onChange={e => this.props.change(e)} data-type="dc" type="number"
                                               spellCheck="false"/>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 mb-4">
                            <div className="row">
                                <div className="col-5">
                                    <h5 className="card-title">Überstand außen (mm)</h5>
                                    <div className="form-group">
                                        <div className="input-group">
                                            <input className="form-control cross-slope"
                                                   defaultValue={showEdit && parseInt(editValue.overHangOutside)}
                                                   onChange={e => this.props.change(e)} data-type="overHangOutside"
                                                   type="number" data-suffix="mm" spellCheck="false"/>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-5">
                                    <h5 className="card-title">Überstand innen (mm)</h5>
                                    <div className="form-group">
                                        <div className="input-group">
                                            <input className="form-control cross-slope"
                                                   defaultValue={showEdit && parseInt(editValue.overHangInside)}
                                                   onChange={e => this.props.change(e)} data-type="overHangInside"
                                                   type="number" data-suffix="mm" spellCheck="false"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 mb-4">
                            <div className="row">
                                <div className="col-5">

                                    <h5 className="card-title">Quergefälle (mm)</h5>
                                    <div className="form-group">
                                        <div className="input-group">
                                            <input className="form-control cross-slope" step="any" placeholder="mm"
                                                   defaultValue={editValue.crossSlopeMM && parseFloat(editValue.crossSlopeMM)}
                                                   value={(this.props.mm && parseFloat(this.props.mm))} onChange={e => {
                                                // this.degreeChange(e.target.value, "mm");
                                                console.log("change");
                                                this.props.change(e)
                                            }} data-type="crossSlopeMM" type="number" data-suffix="mm"
                                                   spellCheck="false"/>
                                            <input className="form-control cross-slope" step="any" placeholder="&deg;"
                                                   defaultValue={editValue.crossSlopeDeg && parseFloat(editValue.crossSlopeDeg)}
                                                   value={(this.props.deg && parseFloat(this.props.deg))}
                                                   onChange={e => {
                                                       //this.degreeChange(e.target.value, "deg");
                                                       this.props.change(e)
                                                   }} data-type="crossSlopeDeg" type="text" spellCheck="false"/>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-5">
                                    <h5 className="card-title">Laufmeter <i data-tip={true} className="icon icon-info"
                                                                            data-for='laufmeter-info'></i></h5>
                                    <ReactTooltip type="dark" id='laufmeter-info'>
                                        <span>inkl. Aller Formteile</span>
                                    </ReactTooltip>
                                    <div className="form-group">
                                        <input className="form-control running-meter"
                                               defaultValue={showEdit && parseInt(editValue.runninMeter)}
                                               onChange={e => this.props.change(e)} data-type="runninMeter"
                                               type="number" data-suffix="m" spellCheck="false"/>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 mb-4">
                            <div className="row">
                                {/*<div className="col-4">
                                    <h5 className="card-title">Zuschnittlänge</h5>
                                    <div className="form-group">
                                        <select className="form-control cutting-length"
                                                onChange={e => this.props.change(e)} data-type="cuttingLength"
                                                data-suffix="m">
                                            <option value="3">3m</option>
                                            <option value="4">4m</option>
                                            <option value="5">5m</option>
                                        </select>
                                    </div>
                                </div>*/}
                                <div className="col-4">
                                    <h5 className="card-title">Blechstärke</h5>
                                    <div className="form-group">
                                        <select className="form-control sheet-thickness"
                                                onChange={e => this.props.change(e)} data-type="sheetThickness"
                                                data-field="sheet-thickness" data-suffix="mm">
                                            <option value="1,5">1,5mm</option>
                                            <option value="2,0">2,0mm</option>
                                            <option value="2,5">2,5mm</option>
                                            <option value="3,0">3,0mm</option>
                                            <option value="4,00">4,0mm</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-4">
                                    <h5 className="card-title">Halterabstand</h5>
                                    <div className="form-group">
                                        <select className="form-control bracket-space"
                                                onChange={e => this.props.change(e)} data-type="bracketSpace"
                                                data-suffix="m">
                                            <option value="0,5">0,5m</option>
                                            <option value="0,75">0,75m</option>
                                            <option value="1">1m</option>
                                            <option value="1,25">1,25m</option>
                                            <option value="1,5">1,5m</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-12">
                            <div className="row">
                                <div className="col-6 mb-4">
                                    <h5 className="card-title">Beschichtung</h5>
                                    <div className="form-group">
                                        <Select options={colors} defaultValue={colors[0]} styles={colourStyles}
                                                onChange={(e, a) => this.props.change({}, "color", e.label)}/>
                                    </div>
                                </div>

                                <div className="col-6 mb-4">
                                    <h5 className="card-title">Sonderfarbton</h5>
                                    <div className="form-group">
                                        <input className="form-control"
                                               defaultValue={(showEdit && editValue.sonderfarbton) ? editValue.sonderfarbton : ""}
                                               onChange={e => this.props.change(e)} data-type="sonderfarbton"
                                               type="text" spellCheck="false"/>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <button className="d-none" type="submit" id={"submit-btn" + this.props.id}>Submit</button>
                </form>
            </div>
        )
    }
}

export default Profiles;
